import { Badge } from '@chakra-ui/react'

/**
 * JavaScript/TypeScript
 */

export const ReactBadge = () => {
    return <Badge colorScheme={'teal'}>ReactJS</Badge>
}

export const NextBadge = () => {
    return <Badge colorScheme={'teal'}>NextJS</Badge>
}

export const NodeBadge = () => {
    return <Badge colorScheme={'green'}>NodeJS</Badge>
}

export const TypescriptBadge = () => {
    return <Badge colorScheme={'blue'}>Typescript</Badge>
}

/**
 * Python
 */

export const PythonBadge = () => {
    return <Badge colorScheme={'blue'}>Python</Badge>
}

export const FastAPIBadge = () => {
    return <Badge colorScheme={'green'}>FastAPI</Badge>
}

export const DjangoBadge = () => {
    return <Badge colorScheme={'green'}>Django</Badge>
}

/**
 * Databases
 */

export const MySQLBadge = () => {
    return <Badge colorScheme={'orange'}>MySQL</Badge>
}

export const PostgreSQLBadge = () => {
    return <Badge colorScheme={'blue'}>PostgreSQL</Badge>
}

export const PHPBadge = () => {
    return <Badge colorScheme={'purple'}>PHP</Badge>
}

export const FirebaseBadge = () => {
    return <Badge colorScheme={'orange'}>Firebase</Badge>
}

export const MongoBadge = () => {
    return <Badge colorScheme={'green'}>MongoDB</Badge>
}

/**
 * Other languages/technologies
 */

export const JavaBadge = () => {
    return <Badge colorScheme={'red'}>Java</Badge>
}

export const AssemblyBadge = () => {
    return <Badge colorScheme={'orange'}>Assembly</Badge>
}

export const RBadge = () => {
    return <Badge colorScheme={'blue'}>R</Badge>
}

export const SQLBadge = () => {
    return <Badge colorScheme={'orange'}>SQL</Badge>
}

export const XGBoostBadge = () => {
    return <Badge colorScheme={'green'}>XGBoost</Badge>
}

export const PyTorchBadge = () => {
    return <Badge colorScheme={'red'}>PyTorch</Badge>
}

export const D3Badge = () => {
    return <Badge colorScheme={'orange'}>D3.js</Badge>
}

export const MachineLearningBadge = () => {
    return <Badge colorScheme={'purple'}>Machine Learning</Badge>
}

export const HPCBadge = () => {
    return <Badge colorScheme={'gray'}>HPC</Badge>
}

export const LLMBadge = () => {
    return <Badge colorScheme={'purple'}>LLM</Badge>
}

export const RAGBadge = () => {
    return <Badge colorScheme={'teal'}>RAG</Badge>
}

export const VectorSearchBadge = () => {
    return <Badge colorScheme={'cyan'}>Vector Search</Badge>
}

export const DataVisualizationBadge = () => {
    return <Badge colorScheme={'teal'}>Data Visualization</Badge>
}

export const GPUComputingBadge = () => {
    return <Badge colorScheme={'green'}>GPU Computing</Badge>
}

export const OptimizationBadge = () => {
    return <Badge colorScheme={'blue'}>Optimization</Badge>
}

export const RandomForestBadge = () => {
    return <Badge colorScheme={'green'}>Random Forest</Badge>
}

export const StatisticalModelingBadge = () => {
    return <Badge colorScheme={'orange'}>Statistical Modeling</Badge>
}

export const NetworkAnalysisBadge = () => {
    return <Badge colorScheme={'purple'}>Network Analysis</Badge>
}

export const InteractiveWebBadge = () => {
    return <Badge colorScheme={'teal'}>Interactive Web</Badge>
}

export const StatisticalAnalysisBadge = () => {
    return <Badge colorScheme={'blue'}>Statistical Analysis</Badge>
}

export const FinancialAnalyticsBadge = () => {
    return <Badge colorScheme={'green'}>Financial Analytics</Badge>
}

export const ReinforcementLearningBadge = () => {
    return <Badge colorScheme={'red'}>Reinforcement Learning</Badge>
}

export const SimulationBadge = () => {
    return <Badge colorScheme={'cyan'}>Simulation</Badge>
}
